import { dataUserCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCircleSolid = /*#__PURE__*/createIcon(dataUserCircleSolid)
export default IconUserCircleSolid
